import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  styled,
  Radio,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { useFormik } from "formik";
import { useTheme } from "@mui/material/styles";
import * as Yup from "yup";
import Step1 from "./Step1";
import Step2 from "./Step2";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addGoal } from "../../../api/addGoal";
import AgeConsentModal from "../../Modals/user/ageConsentModal/Modal";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import { useSearchParams } from "react-router-dom";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #414466",
      outline: "none",
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const StyledRadio = styled(Radio)(({ theme }) => ({
  display: "none",
  //   opacity: "0",
}));

const StyledRadioLable = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checked",
})(({ theme, checked }) => ({
  margin: theme.spacing(1),
  padding: "15px 20px",
  backgroundColor: checked ? "#FFCD1F" : "#343759",
  borderRadius: "40px",
  cursor: "pointer",
  fontFamily: "Arial",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "17px",
  lineHeight: "17px",
  letterSpacing: "0.02em",

  color: checked ? "black" : "#ffffff",

  //   opacity: "0.6",
  padding: "15px 20px",
  textTransform: "none",

  "& .Mui-checked ": {
    backgroundColor: "#FFCD1F",
    color: "black",
  },
}));

const categories = [
  { id: 1, name: "Men's" },
  { id: 2, name: "Women's" },
  { id: 3, name: "Boy's" },
  { id: 4, name: "Girl's" },
];

const step1Fields = [
  "title",
  "category",
  "from_uk",
  "region",
  "club",
  "goal_scorer",
  "club_img",
  // "subCategory",
  // "childCategory",
  // "comments",
];

const step1editedfields = [
  "title",
  "category",
  "from_uk",
  "region",
  "club",
  "goal_scorer",
  "club_img",
  "subCategory",
  "childCategory",
];

const AddGoalForm = ({ editGoalDetails }) => {
  const theme = useTheme();
  const [next, setNext] = useState(false);
  const userData = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ageConsent, setAgeConsent] = useState(false);
  const [confirmAgeConsent, setConfirmAgeConsent] = useState(false);
  const [searchParams] = useSearchParams();

  const [cat, setcat] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const formRef = useRef(null);

  const from = searchParams.get("from");

  let initialValues;
  if (editGoalDetails) {
    initialValues = {
      title: editGoalDetails?.[0]?.title || "",
      category: editGoalDetails?.[0]?.category || 1,
      from_uk: editGoalDetails?.[0]?.from_uk ? 1 : 0,
      region: editGoalDetails?.[0]?.region || "",
      club: editGoalDetails[0]?.club || "",
      videoFile: editGoalDetails?.[0]?.video_link || "",
      goal_scorer: editGoalDetails?.[0]?.goal_scorer || "",
      club_img: editGoalDetails?.[0]?.club_img || "",
      comments: editGoalDetails?.[0]?.comments || false, // 0 for false, 1 for true
      subCategory: editGoalDetails?.[0]?.gBGSubCategory || null,
      childCategory: editGoalDetails?.[0]?.sub_category || null,
    };
  } else {
    initialValues = {
      title: "",
      category: null,
      subCategory: "",
      childCategory: "",
      from_uk: null,
      region: "",
      club: "",
      videoFile: "",
      goal_scorer: "",
      club_img: "",
      comments: true, // 0 for false, 1 for true
    };
  }

  const newLocal = true;
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      category: Yup.number().required("Please select video category"),
      subCategory: Yup.string()
        .nullable()
        .when("category", {
          is: 6,
          then: (schema) => schema.required("Please select Boys or Girls"),

          otherwise: (schema) => {},
        }),
      childCategory: Yup.string()
        .nullable()
        .when("subCategory", {
          is: (value) => value,
          then: (schema) =>
            schema.required("Please select age category for Boys or Girls"),

          otherwise: (schema) => {},
        }),
      from_uk: Yup.number().required("Video From is required"),
      region: Yup.string().required("Region is required"),
      club: Yup.string().required("Football Club Name is required"),
      videoFile: Yup.mixed().required("Video is required"),
      goal_scorer: Yup.string().required("Goal Scorer Name is required"),
      club_img: Yup.mixed().required("Club Image is required"),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, resetForm }) => {

      try {
        // "";
        const data = {
          title: values.title,
          category: values.category,
          from_uk: values.from_uk,
          region: values.region,
          club: values.club,
          videoFile: values.videoFile,
          user_id: userData.data.id,
          goal_scorer: values.goal_scorer,
          club_img: values.club_img,
          comments: values.comments,
          subCategory: values.childCategory,
        };
     
        setLoading(true);
        let resdata;
        if (editGoalDetails) {
          // console.log(
          //   "in addd goall*********************************************** edit"
          // );
          data.goal_id = editGoalDetails[0].id;
          resdata = await addGoal("editGoal", data, token);
        } else {
          // console.log(
          //   "in addd goall*********************************************** create"
          // );
          resdata = await addGoal("addGoal", data, token);
        }
        if (resdata.success) {
          toast.success(resdata.message);
          setNext(false);
          navigate("/");
        } else {
          toast.error(resdata.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useSkipFirstRender(() => {
    if (formik.values.category == 6) {
      setAgeConsent(true);
    } else {
      setConfirmAgeConsent(false);
    }
  }, [formik.values.category]);

  useSkipFirstRender(() => {
    if (!confirmAgeConsent && formik.values.category == 6 && !ageConsent) {
      formik.setFieldValue("category", null);
    }
  }, [ageConsent]);

  // "";

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="addGoal-inner">
        <Box className="addGoal-header">
          {
            next ? (
              <Button
                sx={{
                  alignItems: "center",
                  gap: "5px",
                  position: "unset !important",
                }}
                onClick={() => setNext(false)}
              >
                {" "}
                <KeyboardBackspaceIcon
                  sx={{ color: "white", fontSize: { xs: "20px", md: "30px" } }}
                />
                <Typography component="h3">Back</Typography>{" "}
              </Button>
            ) : (
              <>
                <Button
                  sx={{ alignItems: "center", gap: "5px" }}
                  onClick={() => {
                    if (editGoalDetails) {
                      navigate("/myaccount/goals");
                    } else {
                      navigate("/");
                    }
                  }}
                >
                  {" "}
                  <KeyboardBackspaceIcon
                    sx={{
                      color: "white",
                      fontSize: { xs: "20px", md: "30px" },
                    }}
                  />{" "}
                  <Typography component="h3">Back</Typography>{" "}
                </Button>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography component="h1">
                    {editGoalDetails ? "EDIT GOAL" : "UPLOAD GOAL"}
                  </Typography>
                </Box>
              </>
            )
            // null
          }
        </Box>
        <form
          className="addGoal-form"
          onSubmit={formik.handleSubmit}
          ref={formRef}
        >
          {next ? (
            <>
              <Step2 formik={formik} edited={editGoalDetails ? true : false} />
              {submitted && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.touched.videoFile || formik.errors.videoFile
                    ? formik.errors.videoFile
                    : ""}
                </FormHelperText>
              )}
            </>
          ) : (
            <Step1
              formik={formik}
              edited={editGoalDetails ? true : false}
              from={from}
            />
          )}

          <Box className="btn-group" sx={{ width: "100%" }}>
            <Button
              variant="contained"
              className="btn"
              onClick={async () => {
                if (!next) {
                  if (!editGoalDetails) {
                    console.log(
                      formik.errors,
                      "lskdaflsakf error before before before",
                      formik.values,
                    );
                    await formik.validateForm();
                    formik.handleSubmit();
                    console.log(
                      formik.errors,
                      "lskdaflsakf error before ",
                      formik.values,
                    );
                    const errorFields = [];

                    console.log(
                      step1Fields.some((field) => {
                        console.log(
                          "field",
                          field,
                          "error",
                          formik.errors[field],
                          "-- touched",
                          formik.touched[field],
                        );
                        if (formik.errors[field] || !formik.touched[field]) {
                          errorFields.push(field);
                          return true;
                        } else {
                          return false;
                        }
                      }),
                      "lksadflakdflsakfdf",
                    );

                    const error = step1Fields.some((field) => {
                      console.log(
                        formik.errors[field],
                        "kldafalkf",
                        formik.touched[field],
                      );
                      if (formik.errors[field] || !formik.touched[field]) {
                        errorFields.push(field);
                        return true;
                      } else {
                        return false;
                      }
                    });
                    if (error) {
                      // toast.error(
                      //   `Please fill all the required fields \n ${errorFields.join(
                      //     " , ",
                      //   )}`,
                      // );
                      return;
                    }
                    setNext(true);
                  } else {
                    step1editedfields.map((field) => {
                      formik.setFieldTouched(field, true);
                    });
                    await formik.validateForm();
                    const errorFields = [];
                    const errorvalue = step1Fields.some((field) => {
                      console.log(
                        formik.errors[field],
                        "kldafalkf",
                        formik.touched[field],
                      );
                      if (formik.errors[field]) {
                        errorFields.push(field);
                        return true;
                      } else {
                        return false;
                      }
                    });
                    if (errorvalue || Object.keys(formik.errors).length > 0) {
                      toast.error(
                        `Please fill all the required fields \n ${errorFields.join(
                          " , ",
                        )}`,
                      );
                      return;
                    }
                    setNext(true);
                  }
                } else {
                  if (formRef.current) {
                    setSubmitted(true);
                    formik.handleSubmit();
                  }
                }
              }}
            >
              {!next ? "Next" : editGoalDetails ? "Update" : "Publish"}
            </Button>
          </Box>
        </form>
      </Box>
      <AgeConsentModal
        open={ageConsent}
        setOpen={setAgeConsent}
        confirm={confirmAgeConsent}
        setConfirm={setConfirmAgeConsent}
      />
    </>
  );
};

export default AddGoalForm;
